<template>
  <CCardBody>
    <div>
      <strong>UI Branding</strong>
    </div>
    <template v-if="$can('view-general-settings')">
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group label-for="logo">
                <label>Theme Color</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group label-for="logo">
                <div ref="colorPickerContainer" class="position-relative">
                  <div class="color-box d-flex align-items-center justify-content-between position-relative border border-2 p-1 w-25 cursor-pointer" @click.stop="toggleColorPicker">
                    <div class="color-box-inner p-2 w-50" :style="{
                      'background-color': themeColor
                    }"></div>
                    <span>{{ themeColor }}</span>
                  </div>
                  <div v-if="showColorPicker" ref="colorPicker" class="mt-2 position-absolute" style="z-index: 1000;">
                    <color-picker theme="light" @changeColor="changeColor" :color="themeColor" />
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 my-1">
                <b-form-group>
                    <label for="border-radius">Border radius</label>
                </b-form-group>
            </div>
            <div class="col-md-6 my-1">
                <b-form-group class="w-25">
                    <b-form-input
                        id="border-radius"
                        type="range"
                        min="0"
                        max="1"
                        step="0.1"
                        v-model.number="borderRadius"
                    ></b-form-input>
                    <div>
                        <strong>{{ borderRadius }}rem</strong>
                    </div>
                </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 my-1">
                <b-form-group>
                    <label for="theme">Allow Color mode switch</label>
                </b-form-group>
            </div>
            <div class="col-md-6 my-1">
                <b-form-group>
                    <b-form-checkbox v-model="allowColorModeSwitch" name="allowColorModeSwitch" switch></b-form-checkbox>
                </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 my-1">
                <b-form-group>
                    <label for="disable-category-navigation-logos">Disable Category Navigation Logos</label>
                </b-form-group>
            </div>
            <div class="col-md-6 my-1">
                <b-form-group>
                    <b-form-checkbox v-model="disableCategoryNavigationLogos" name="disableCategoryNavigationLogos" switch></b-form-checkbox>
                </b-form-group>
            </div>
          </div>
          <div class="row align-items-start">
            <div class="col-md-3 my-1">
                <b-form-group>
                    <label id="category-nav-style-label" class="mb-0">Category Navigation Style</label>
                </b-form-group>
            </div>
            <div class="col-md-6 my-1">
                <div
                    id="stepper-navigation"
                    class="navigation-style-radios"
                    role="radiogroup"
                    aria-labelledby="category-nav-style-label"
                >
                    <div class="navigation-style-option">
                        <div class="navigation-style-option__head">
                            <input
                                id="category-nav-stepper"
                                v-model="enableStepperNavigation"
                                type="radio"
                                class="form-check-input navigation-style-option__radio"
                                name="stepperNavigation"
                                :value="true"
                            />
                            <label class="navigation-style-option__text" for="category-nav-stepper">Stepper</label>
                        </div>
                        <label for="category-nav-stepper" class="navigation-preview">
                            <img
                                src="/img/images/stepper.png"
                                alt="Stepper layout preview"
                                class="navigation-preview__img"
                            />
                        </label>
                    </div>
                    <div class="navigation-style-option">
                        <div class="navigation-style-option__head">
                            <input
                                id="category-nav-non-stepper"
                                v-model="enableStepperNavigation"
                                type="radio"
                                class="form-check-input navigation-style-option__radio"
                                name="stepperNavigation"
                                :value="false"
                            />
                            <label class="navigation-style-option__text" for="category-nav-non-stepper">Panel Shift</label>
                        </div>
                        <label for="category-nav-non-stepper" class="navigation-preview navigation-preview--shift-panel">
                            <img
                                src="/img/images/non-stepper.png"
                                alt="Shift Panel layout preview"
                                class="navigation-preview__img navigation-preview__img--shift-panel"
                            />
                        </label>
                    </div>
                </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 my-1">
                <b-form-group>
                    <label for="theme">Theme</label>
                </b-form-group>
            </div>
            <div class="col-md-6 my-1">
                <b-form-group>
                    <b-form-radio-group
                        id="theme"
                        v-model="theme"
                        :options="themeOptions"
                        name="theme"
                    ></b-form-radio-group>
                </b-form-group>
            </div>
          </div>
          <!-- Brand Font Section -->
          <div class="row mt-3">
            <div class="col-12">
              <h5 class="mb-3">Brand Font (for headings)</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 my-1">
                <b-form-group>
                    <label for="brand-font-source">Font Source</label>
                </b-form-group>
            </div>
            <div class="col-md-6 my-1">
                <b-form-group>
                    <b-form-radio-group
                        id="brand-font-source"
                        v-model="brandFontSource"
                        :options="fontSourceOptions"
                        name="brand-font-source"
                        @input="handleBrandFontSourceChange"
                    ></b-form-radio-group>
                </b-form-group>
            </div>
          </div>
          <div class="row" v-if="brandFontSource === 'google'">
            <div class="col-md-3 my-1">
                <b-form-group>
                    <label for="brand-font">Google Font</label>
                </b-form-group>
            </div>
            <div class="col-md-6 my-1">
                <b-form-group>
                    <v-select
                        id="brand-font"
                        v-model="brandFont"
                        :options="displayedFonts"
                        label="family"
                        :reduce="option => ({ family: option.family, url: `https://fonts.googleapis.com/css2?family=${option.family.replace(/\s+/g, '+')}:wght@400;700&display=swap` })"
                        name="brand-font"
                        placeholder="Search any font from the Google Fonts database..."
                        @search="handleFontSearch"
                    ></v-select>
                    <div v-if="selectedBrandFont && typeof selectedBrandFont === 'object' && selectedBrandFont.family" class="mt-3">
                        <div class="font-preview-container p-3 border rounded" :style="{ fontFamily: `'${selectedBrandFont.family}', sans-serif` }">
                            <div class="font-preview-text">
                                <div class="mb-2">
                                    <strong>Brand Font Preview:</strong>
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    The quick brown fox jumps over the lazy dog
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    ABCDEFGHIJKLMNOPQRSTUVWXYZ
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    abcdefghijklmnopqrstuvwxyz
                                </div>
                                <div style="font-size: 24px;">
                                    0123456789 !@#$%^&*()
                                </div>
                            </div>
                        </div>
                    </div>
                </b-form-group>
            </div>
          </div>
          <div class="row" v-if="brandFontSource === 'custom'">
            <div class="col-md-3 my-1">
                <b-form-group>
                    <label for="brand-custom-font-file">Custom Font Upload</label>
                </b-form-group>
            </div>
            <div class="col-md-6 my-1">
                <b-form-group>
                    <b-form-file
                        id="brand-custom-font-file"
                        v-model="brandCustomFontFile"
                        accept=".woff,.woff2,.ttf,.otf"
                        name="brand-custom-font-file"
                        placeholder="Choose a font file (.woff, .woff2, .ttf, or .otf)..."
                        drop-placeholder="Drop font file here..."
                        @input="handleBrandCustomFontUpload"
                    ></b-form-file>
                    <small class="form-text text-muted">Only .woff, .woff2, .ttf, and .otf files are allowed</small>
                    <div v-if="brandCustomFontFile" class="mt-1">
                        <small class="text-success">File selected: {{ brandCustomFontFile.name || brandCustomFontFile }}</small>
                    </div>
                    <div v-if="brandCustomFontName" class="mt-3">
                        <div class="font-preview-container p-3 border rounded" :style="{ fontFamily: `'${brandCustomFontName}', sans-serif` }">
                            <div class="font-preview-text">
                                <div class="mb-2">
                                    <strong>Brand Font Preview:</strong>
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    The quick brown fox jumps over the lazy dog
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    ABCDEFGHIJKLMNOPQRSTUVWXYZ
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    abcdefghijklmnopqrstuvwxyz
                                </div>
                                <div style="font-size: 24px;">
                                    0123456789 !@#$%^&*()
                                </div>
                            </div>
                        </div>
                    </div>
                </b-form-group>
            </div>
          </div>
          
          <!-- Default Font Section -->
          <div class="row mt-3">
            <div class="col-12">
              <h5 class="mb-3">Default Font (for texts/labels)</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 my-1">
                <b-form-group>
                    <label for="default-font-source">Font Source</label>
                </b-form-group>
            </div>
            <div class="col-md-6 my-1">
                <b-form-group>
                    <b-form-radio-group
                        id="default-font-source"
                        v-model="defaultFontSource"
                        :options="fontSourceOptions"
                        name="default-font-source"
                        @input="handleDefaultFontSourceChange"
                    ></b-form-radio-group>
                </b-form-group>
            </div>
          </div>
          <div class="row" v-if="defaultFontSource === 'google'">
            <div class="col-md-3 my-1">
                <b-form-group>
                    <label for="default-font">Google Font</label>
                </b-form-group>
            </div>
            <div class="col-md-6 my-1">
                <b-form-group>
                    <v-select
                        id="default-font"
                        v-model="defaultFont"
                        :options="displayedFonts"
                        label="family"
                        :reduce="option => ({ family: option.family, url: `https://fonts.googleapis.com/css2?family=${option.family.replace(/\s+/g, '+')}:wght@400;700&display=swap` })"
                        name="default-font"
                        placeholder="Search any font from the Google Fonts database..."
                        @search="handleFontSearch"
                    ></v-select>
                    <div v-if="selectedDefaultFont && typeof selectedDefaultFont === 'object' && selectedDefaultFont.family" class="mt-3">
                        <div class="font-preview-container p-3 border rounded" :style="{ fontFamily: `'${selectedDefaultFont.family}', sans-serif` }">
                            <div class="font-preview-text">
                                <div class="mb-2">
                                    <strong>Default Font Preview:</strong>
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    The quick brown fox jumps over the lazy dog
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    ABCDEFGHIJKLMNOPQRSTUVWXYZ
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    abcdefghijklmnopqrstuvwxyz
                                </div>
                                <div style="font-size: 24px;">
                                    0123456789 !@#$%^&*()
                                </div>
                            </div>
                        </div>
                    </div>
                </b-form-group>
            </div>
          </div>
          <div class="row" v-if="defaultFontSource === 'custom'">
            <div class="col-md-3 my-1">
                <b-form-group>
                    <label for="default-custom-font-file">Custom Font Upload</label>
                </b-form-group>
            </div>
            <div class="col-md-6 my-1">
                <b-form-group>
                    <b-form-file
                        id="default-custom-font-file"
                        v-model="defaultCustomFontFile"
                        accept=".woff,.woff2,.ttf,.otf"
                        name="default-custom-font-file"
                        placeholder="Choose a font file (.woff, .woff2, .ttf, or .otf)..."
                        drop-placeholder="Drop font file here..."
                        @input="handleDefaultCustomFontUpload"
                    ></b-form-file>
                    <small class="form-text text-muted">Only .woff, .woff2, .ttf, and .otf files are allowed</small>
                    <div v-if="defaultCustomFontFile" class="mt-1">
                        <small class="text-success">File selected: {{ defaultCustomFontFile.name || defaultCustomFontFile }}</small>
                    </div>
                    <div v-if="defaultCustomFontName" class="mt-3">
                        <div class="font-preview-container p-3 border rounded" :style="{ fontFamily: `'${defaultCustomFontName}', sans-serif` }">
                            <div class="font-preview-text">
                                <div class="mb-2">
                                    <strong>Default Font Preview:</strong>
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    The quick brown fox jumps over the lazy dog
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    ABCDEFGHIJKLMNOPQRSTUVWXYZ
                                </div>
                                <div style="font-size: 24px; margin-bottom: 8px;">
                                    abcdefghijklmnopqrstuvwxyz
                                </div>
                                <div style="font-size: 24px;">
                                    0123456789 !@#$%^&*()
                                </div>
                            </div>
                        </div>
                    </div>
                </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-9 my-2">
          <div class="row my-3 align-items-right">
            <div class="d-flex" style="justify-content: flex-end; width: 100%; padding-right: 15px">
              <button class="btn btn-primary" @click="saveUIBranding">Save</button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </CCardBody>
</template>

<script>
import { http } from "@/config/httpCommon";
import colorPicker from "@caohenghu/vue-colorpicker";
import { handleResponseException } from "@/helpers/Helpers";

export default {
  name: 'UIBranding',
  components: {
    colorPicker
  },
  data() {
    return {
      company: null,
      themeColor: '#219F84',
      showColorPicker: false,
      borderRadius: 0.5,
      theme: 'light',
      themeOptions: [
        { text: 'Light', value: 'light' },
        { text: 'Dark', value: 'dark' }
      ],
      // Brand font properties
      brandFont: '',
      brandFontSource: 'google',
      brandCustomFontFile: null,
      brandCustomFontName: null,
      brandCustomFontUrl: null,
      selectedBrandFont: null,
      // Default font properties
      defaultFont: '',
      defaultFontSource: 'google',
      defaultCustomFontFile: null,
      defaultCustomFontName: null,
      defaultCustomFontUrl: null,
      selectedDefaultFont: null,
      // Shared font properties
      fontSourceOptions: [
        { text: 'Google Font', value: 'google' },
        { text: 'Custom Font Upload', value: 'custom' }
      ],
      googleFontsApiKey: process.env.VUE_APP_GOOGLE_FONTS_API_KEY,
      googleFonts: [],
      displayedFonts: [],
      allFonts: [],
      loadedFonts: new Set(),
      storage_url: process.env.VUE_APP_FILE_URL,
      uiBranding: {},
      allowColorModeSwitch: false,
      enableStepperNavigation: false,
      disableCategoryNavigationLogos: false
    }
  },
  created() {
    this.company = this.$store.getters.company
    this.$store.dispatch('fetchGoogleFonts').then(res => {
      this.allFonts = res.items
      this.googleFonts = res.items.slice(0, 50)
      this.displayedFonts = this.googleFonts;
    });
    this.$store.dispatch('fetchUiBranding').then((res) => {
      this.theme = res.data.result.value.theme || 'light';
      this.themeColor = res.data.result.value.theme_color || '#219F84';
      this.borderRadius = res.data.result.value.border_radius || 0.5;
      this.allowColorModeSwitch = res.data.result.value.allow_color_mode_switch || false;
      this.disableCategoryNavigationLogos = res.data.result.value.disable_category_navigation_logos ?? false;
      this.enableStepperNavigation = res.data.result.value.enable_stepper_navigation ?? false;
      this.uiBranding = res.data.result.value;
      
      // Load brand font
      if (res.data.result.value.brand_font_is_custom && res.data.result.value.brand_font_file) {
        // Load custom brand font from S3 URL
        const fontFileUrl = res.data.result.value.brand_font_file.startsWith('http') 
          ? res.data.result.value.brand_font_file 
          : `${this.storage_url}/${res.data.result.value.brand_font_file}`;
        this.loadExistingBrandCustomFont(fontFileUrl, res.data.result.value.brand_font_name);
        this.brandFontSource = 'custom';
      } else if (res.data.result.value.brand_font_family) {
        // Load Google brand font
        this.brandFont = { family: res.data.result.value.brand_font_family };
        this.selectedBrandFont = this.brandFont;
        this.brandFontSource = 'google';
      }
      
      // Load default font
      if (res.data.result.value.default_font_is_custom && res.data.result.value.default_font_file) {
        // Load custom default font from S3 URL
        const fontFileUrl = res.data.result.value.default_font_file.startsWith('http') 
          ? res.data.result.value.default_font_file 
          : `${this.storage_url}/${res.data.result.value.default_font_file}`;
        this.loadExistingDefaultCustomFont(fontFileUrl, res.data.result.value.default_font_name);
        this.defaultFontSource = 'custom';
      } else if (res.data.result.value.default_font_family) {
        // Load Google default font
        const fontFamily = this.extractFontFamilyFromUrl(res.data.result.value.default_font_family);
        this.defaultFont = fontFamily ? { family: fontFamily, url: res.data.result.value.default_font_family } : null;
        if (fontFamily) {
          this.selectedDefaultFont = this.defaultFont;
          this.loadGoogleFont(fontFamily);
          this.defaultFontSource = 'google';
        }
      }
    })
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
    // Clean up brand custom font resources
    if (this.brandCustomFontUrl) {
      URL.revokeObjectURL(this.brandCustomFontUrl)
      const style = document.getElementById('brand-custom-font-style')
      if (style) {
        document.head.removeChild(style)
      }
    }
    // Clean up default custom font resources
    if (this.defaultCustomFontUrl) {
      URL.revokeObjectURL(this.defaultCustomFontUrl)
      const style = document.getElementById('default-custom-font-style')
      if (style) {
        document.head.removeChild(style)
      }
    }
  },
  watch: {
    brandFont(newValue) {
      // Only load Google font if Google font source is selected
      if (this.brandFontSource === 'google' && newValue && typeof newValue === 'object' && newValue.family) {
        // Clear custom font when Google font is selected
        this.clearBrandCustomFont()
        this.loadGoogleFont(newValue.family)
      }
      this.selectedBrandFont = newValue
    },
    defaultFont(newValue) {
      // Only load Google font if Google font source is selected
      if (this.defaultFontSource === 'google' && newValue && typeof newValue === 'object' && newValue.family) {
        // Clear custom font when Google font is selected
        this.clearDefaultCustomFont()
        this.loadGoogleFont(newValue.family)
      }
      this.selectedDefaultFont = newValue
    }
  },
  methods: {
    toggleColorPicker() {
      this.showColorPicker = !this.showColorPicker
    },
    changeColor(color) {
      // Convert to hex format
      if (color.hex) {
        this.themeColor = color.hex
      } else {
        // Fallback: convert RGB to hex if hex property is not available
        const { r, g, b } = color.rgba || color.rgb || {}
        const toHex = (n) => {
          const hex = Math.round(n).toString(16)
          return hex.length === 1 ? '0' + hex : hex
        }
        this.themeColor = `#${toHex(r)}${toHex(g)}${toHex(b)}`
      }
    },
    finalizeColorSelection() {
      this.showColorPicker = false
    },
    handleClickOutside(event) {
      if (this.showColorPicker && this.$refs.colorPickerContainer) {
        if (!this.$refs.colorPickerContainer.contains(event.target)) {
          this.showColorPicker = false
        }
      }
    },
    handleBrandFontSourceChange(source) {
      if (source === 'google') {
        // Clear custom font when switching to Google Fonts
        this.clearBrandCustomFont()
      } else if (source === 'custom') {
        // Clear Google font selection when switching to custom font
        this.brandFont = null
        this.selectedBrandFont = null
      }
    },
    handleDefaultFontSourceChange(source) {
      if (source === 'google') {
        // Clear custom font when switching to Google Fonts
        this.clearDefaultCustomFont()
      } else if (source === 'custom') {
        // Clear Google font selection when switching to custom font
        this.defaultFont = null
        this.selectedDefaultFont = null
      }
    },
    clearBrandCustomFont() {
      if (this.brandCustomFontUrl) {
        URL.revokeObjectURL(this.brandCustomFontUrl)
        const link = document.getElementById('brand-custom-font-link')
        if (link) {
          document.head.removeChild(link)
        }
        const style = document.getElementById('brand-custom-font-style')
        if (style) {
          document.head.removeChild(style)
        }
      }
      this.brandCustomFontFile = null
      this.brandCustomFontName = null
      this.brandCustomFontUrl = null
    },
    clearDefaultCustomFont() {
      if (this.defaultCustomFontUrl) {
        URL.revokeObjectURL(this.defaultCustomFontUrl)
        const link = document.getElementById('default-custom-font-link')
        if (link) {
          document.head.removeChild(link)
        }
        const style = document.getElementById('default-custom-font-style')
        if (style) {
          document.head.removeChild(style)
        }
      }
      this.defaultCustomFontFile = null
      this.defaultCustomFontName = null
      this.defaultCustomFontUrl = null
    },
    getGoogleFontUrl(fontFamily) {
      // Generate Google Fonts CSS URL
      const fontNameEncoded = fontFamily.replace(/\s+/g, '+')
      return `https://fonts.googleapis.com/css2?family=${fontNameEncoded}:wght@400;700&display=swap`
    },
    async loadExistingBrandCustomFont(fontUrl, fontName) {
      try {
        // Extract filename from URL or use font name
        const urlParts = fontUrl.split('/');
        const fileName = urlParts[urlParts.length - 1] || (fontName ? `${fontName}.woff` : 'font.woff');
        
        // Fetch the font file from the URL to create a File object for the input
        const response = await fetch(fontUrl);
        if (!response.ok) {
          console.error('Failed to fetch font file:', response.statusText);
          return;
        }
        
        const blob = await response.blob();
        
        // Create a File object from the blob for the input field
        const file = new File([blob], fileName, { type: blob.type });
        
        // Set the file and URL for preview
        this.brandCustomFontFile = file;
        this.brandCustomFontUrl = fontUrl;
        this.brandCustomFontName = fontName || fileName.replace(/\.(woff|woff2|ttf|otf)$/i, '').replace(/[-_]/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        
        // Load the font using the S3 URL directly
        this.loadBrandCustomFontFromUrl(fontUrl, this.brandCustomFontName);
      } catch (error) {
        console.error('Error loading existing brand custom font:', error);
      }
    },
    async loadExistingDefaultCustomFont(fontUrl, fontName) {
      try {
        // Extract filename from URL or use font name
        const urlParts = fontUrl.split('/');
        const fileName = urlParts[urlParts.length - 1] || (fontName ? `${fontName}.woff` : 'font.woff');
        
        // Fetch the font file from the URL to create a File object for the input
        const response = await fetch(fontUrl);
        if (!response.ok) {
          console.error('Failed to fetch font file:', response.statusText);
          return;
        }
        
        const blob = await response.blob();
        
        // Create a File object from the blob for the input field
        const file = new File([blob], fileName, { type: blob.type });
        
        // Set the file and URL for preview
        this.defaultCustomFontFile = file;
        this.defaultCustomFontUrl = fontUrl;
        this.defaultCustomFontName = fontName || fileName.replace(/\.(woff|woff2|ttf|otf)$/i, '').replace(/[-_]/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        
        // Load the font using the S3 URL directly
        this.loadDefaultCustomFontFromUrl(fontUrl, this.defaultCustomFontName);
      } catch (error) {
        console.error('Error loading existing default custom font:', error);
      }
    },
    loadBrandCustomFontFromUrl(fontUrl, fontName) {
      // Determine font format based on file extension
      const fileName = fontUrl.toLowerCase();
      let fontFormat = 'woff';
      if (fileName.includes('.woff2')) {
        fontFormat = 'woff2';
      } else if (fileName.includes('.ttf')) {
        fontFormat = 'truetype';
      } else if (fileName.includes('.otf')) {
        fontFormat = 'opentype';
      }
      
      // Create @font-face style using the S3 URL
      const style = document.createElement('style');
      style.id = 'brand-custom-font-style';
      style.textContent = `
        @font-face {
          font-family: '${fontName}';
          src: url('${fontUrl}') format('${fontFormat}');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `;
      document.head.appendChild(style);
    },
    loadDefaultCustomFontFromUrl(fontUrl, fontName) {
      // Determine font format based on file extension
      const fileName = fontUrl.toLowerCase();
      let fontFormat = 'woff';
      if (fileName.includes('.woff2')) {
        fontFormat = 'woff2';
      } else if (fileName.includes('.ttf')) {
        fontFormat = 'truetype';
      } else if (fileName.includes('.otf')) {
        fontFormat = 'opentype';
      }
      
      // Create @font-face style using the S3 URL
      const style = document.createElement('style');
      style.id = 'default-custom-font-style';
      style.textContent = `
        @font-face {
          font-family: '${fontName}';
          src: url('${fontUrl}') format('${fontFormat}');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `;
      document.head.appendChild(style);
    },
    extractFontFamilyFromUrl(url) {
      // Extract font family name from Google Fonts URL
      // Example: https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap
      const match = url.match(/family=([^:]+)/);
      if (match && match[1]) {
        return decodeURIComponent(match[1].replace(/\+/g, ' '));
      }
      return null;
    },
    handleBrandCustomFontUpload(file) {
      if (file) {
        // Clear Google font selection when custom font is uploaded
        this.brandFont = null
        this.selectedBrandFont = null
        
        const fileName = file.name.toLowerCase()
        const validExtensions = ['.woff', '.woff2', '.ttf', '.otf']
        const isValidExtension = validExtensions.some(ext => fileName.endsWith(ext))
        
        if (!isValidExtension) {
          this.$toast.error('Invalid file type. Only .woff, .woff2, .ttf, and .otf files are allowed.')
          this.brandCustomFontFile = null
          this.brandCustomFontName = null
          this.brandCustomFontUrl = null
          return
        }
        
        // Remove previous custom font if any
        if (this.brandCustomFontUrl) {
          const oldLink = document.getElementById('brand-custom-font-link')
          if (oldLink) {
            document.head.removeChild(oldLink)
          }
          // Remove old @font-face rule
          const oldStyle = document.getElementById('brand-custom-font-style')
          if (oldStyle) {
            document.head.removeChild(oldStyle)
          }
        }
        
        // Create object URL for the font file
        this.brandCustomFontUrl = URL.createObjectURL(file)
        
        // Extract font name from filename (remove extension)
        this.brandCustomFontName = fileName.replace(/\.(woff|woff2|ttf|otf)$/i, '').replace(/[-_]/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
        
        // Load the custom font
        this.loadBrandCustomFont(file, this.brandCustomFontUrl, this.brandCustomFontName)
      } else {
        // Clear custom font when file is removed
        this.clearBrandCustomFont()
      }
    },
    handleDefaultCustomFontUpload(file) {
      if (file) {
        // Clear Google font selection when custom font is uploaded
        this.defaultFont = null
        this.selectedDefaultFont = null
        
        const fileName = file.name.toLowerCase()
        const validExtensions = ['.woff', '.woff2', '.ttf', '.otf']
        const isValidExtension = validExtensions.some(ext => fileName.endsWith(ext))
        
        if (!isValidExtension) {
          this.$toast.error('Invalid file type. Only .woff, .woff2, .ttf, and .otf files are allowed.')
          this.defaultCustomFontFile = null
          this.defaultCustomFontName = null
          this.defaultCustomFontUrl = null
          return
        }
        
        // Remove previous custom font if any
        if (this.defaultCustomFontUrl) {
          const oldLink = document.getElementById('default-custom-font-link')
          if (oldLink) {
            document.head.removeChild(oldLink)
          }
          // Remove old @font-face rule
          const oldStyle = document.getElementById('default-custom-font-style')
          if (oldStyle) {
            document.head.removeChild(oldStyle)
          }
        }
        
        // Create object URL for the font file
        this.defaultCustomFontUrl = URL.createObjectURL(file)
        
        // Extract font name from filename (remove extension)
        this.defaultCustomFontName = fileName.replace(/\.(woff|woff2|ttf|otf)$/i, '').replace(/[-_]/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
        
        // Load the custom font
        this.loadDefaultCustomFont(file, this.defaultCustomFontUrl, this.defaultCustomFontName)
      } else {
        // Clear custom font when file is removed
        this.clearDefaultCustomFont()
      }
    },
    loadBrandCustomFont(file, fontUrl, fontName) {
      // Determine font format based on file extension
      const fileName = file.name.toLowerCase()
      let fontFormat = 'woff'
      if (fileName.endsWith('.woff2')) {
        fontFormat = 'woff2'
      } else if (fileName.endsWith('.ttf')) {
        fontFormat = 'truetype'
      } else if (fileName.endsWith('.otf')) {
        fontFormat = 'opentype'
      }
      
      console.log(fontUrl, fontName, fontFormat)

      // Create @font-face style
      const style = document.createElement('style')
      style.id = 'brand-custom-font-style'
      style.textContent = `
        @font-face {
          font-family: '${fontName}';
          src: url('${fontUrl}') format('${fontFormat}');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `
      document.head.appendChild(style)
    },
    loadDefaultCustomFont(file, fontUrl, fontName) {
      // Determine font format based on file extension
      const fileName = file.name.toLowerCase()
      let fontFormat = 'woff'
      if (fileName.endsWith('.woff2')) {
        fontFormat = 'woff2'
      } else if (fileName.endsWith('.ttf')) {
        fontFormat = 'truetype'
      } else if (fileName.endsWith('.otf')) {
        fontFormat = 'opentype'
      }
      
      // Create @font-face style
      const style = document.createElement('style')
      style.id = 'default-custom-font-style'
      style.textContent = `
        @font-face {
          font-family: '${fontName}';
          src: url('${fontUrl}') format('${fontFormat}');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `
      document.head.appendChild(style)
    },
    handleFontSearch(search, loading) {
      // If search is empty, show only initial 50 fonts
      if (!search || search.trim() === '') {
        this.displayedFonts = this.googleFonts
        return
      }

      // If all fonts are already loaded, filter from them
      if (this.allFonts.length > 0) {
        const searchLower = search.toLowerCase()
        this.displayedFonts = this.allFonts.filter(font => 
          font.family.toLowerCase().includes(searchLower)
        )
      } else {
        // If not loaded yet, fetch all fonts and filter
        loading(true)
        http.get(`https://www.googleapis.com/webfonts/v1/webfonts?key=${this.googleFontsApiKey}`).then(res => {
          this.allFonts = res.data.items
          const searchLower = search.toLowerCase()
          this.displayedFonts = this.allFonts.filter(font => 
            font.family.toLowerCase().includes(searchLower)
          )
          loading(false)
        }).catch(() => {
          loading(false)
        })
      }
    },
    loadGoogleFont(fontFamily) {
      if (!fontFamily || this.loadedFonts.has(fontFamily)) {
        return
      }

      // Check if font link already exists
      const existingLink = document.getElementById(`google-font-${fontFamily}`)
      if (existingLink) {
        this.loadedFonts.add(fontFamily)
        return
      }

      // Create link element to load Google Font
      const link = document.createElement('link')
      link.id = `google-font-${fontFamily}`
      link.rel = 'stylesheet'
      // Replace spaces with + for URL encoding
      const fontNameEncoded = fontFamily.replace(/\s+/g, '+')
      link.href = `https://fonts.googleapis.com/css2?family=${fontNameEncoded}:wght@400;700&display=swap`
      
      // Add to head
      document.head.appendChild(link)
      
      // Mark as loaded
      this.loadedFonts.add(fontFamily)
      
      // Optional: Wait for font to load before showing preview
      link.onload = () => {
        // Font is loaded, preview will automatically update
      }
    },
    async saveUIBranding() {
      try {
        this.$store.commit('set', ['showLoader', true]);
        let payload;
        
        // Check if any custom font files are uploaded - if so, use FormData
        const hasBrandCustomFont = this.brandFontSource === 'custom' && this.brandCustomFontFile;
        const hasDefaultCustomFont = this.defaultFontSource === 'custom' && this.defaultCustomFontFile;
        
        if (hasBrandCustomFont || hasDefaultCustomFont) {
          const formData = new FormData();
          formData.append('theme_color', this.themeColor);
          formData.append('border_radius', this.borderRadius);
          formData.append('theme', this.theme);
          formData.append('allow_color_mode_switch', this.allowColorModeSwitch ? 1 : 0);
          formData.append('enable_stepper_navigation', String(this.enableStepperNavigation));
          formData.append('disable_category_navigation_logos', this.disableCategoryNavigationLogos ? '1' : '0');
          
          // Brand font data
          formData.append('brand_font_is_custom', this.brandFontSource === 'custom' ? '1' : '0');
          if (hasBrandCustomFont) {
            formData.append('brand_font_file', this.brandCustomFontFile);
            formData.append('brand_font_family', '');
          } else {
            formData.append('brand_font_file', '');
            formData.append('brand_font_family', this.brandFontSource === 'google' && this.brandFont && typeof this.brandFont === 'object' ? this.brandFont.family : '');
          }
          
          // Default font data
          formData.append('default_font_is_custom', this.defaultFontSource === 'custom' ? '1' : '0');
          if (hasDefaultCustomFont) {
            formData.append('default_font_file', this.defaultCustomFontFile);
            formData.append('default_font_family', '');
          } else {
            formData.append('default_font_file', '');
            formData.append('default_font_family', this.defaultFontSource === 'google' && this.defaultFont && typeof this.defaultFont === 'object' ? this.defaultFont.family : '');
          }
          
          // For backward compatibility, also send old font fields if brand font exists
          if (hasBrandCustomFont) {
            formData.append('is_custom_font', '1');
            formData.append('font_file', this.brandCustomFontFile);
            formData.append('font_url', '');
          } else if (this.brandFontSource === 'google' && this.brandFont && typeof this.brandFont === 'object') {
            formData.append('is_custom_font', '0');
            formData.append('font_file', '');
            formData.append('font_url', this.brandFont.family);
          }
          
          payload = formData;
        } else {
          // Regular JSON payload for Google fonts or no font
          payload = {
            theme_color: this.themeColor,
            border_radius: this.borderRadius,
            theme: this.theme,
            allow_color_mode_switch: this.allowColorModeSwitch ? 1 : 0,
            enable_stepper_navigation: this.enableStepperNavigation,
            disable_category_navigation_logos: this.disableCategoryNavigationLogos ? 1 : 0,
            // Brand font data
            brand_font_is_custom: this.brandFontSource === 'custom' ? 1 : 0,
            brand_font_file: null,
            brand_font_family: this.brandFontSource === 'google' && this.brandFont && typeof this.brandFont === 'object' ? this.brandFont.family : null,
            // Default font data
            default_font_is_custom: this.defaultFontSource === 'custom' ? 1 : 0,
            default_font_file: null,
            default_font_family: this.defaultFontSource === 'google' && this.defaultFont && typeof this.defaultFont === 'object' ? this.defaultFont.family : null,
          };
        }
        
        let res = await this.$store.dispatch('saveUIBranding', payload)
        this.$toast.open({
          message: res.data.message,
          title: res.data.status_code === 200 ? 'SUCCESS' : 'ERROR',
          type: res.data.status_code === 200 ? 'success' : 'error',
          dismissible: true,
          duration: 5000,
          position: 'bottom-left'
        })
        this.$store.commit('set', ['showLoader', false]);
      } catch (error) {
        handleResponseException(error)
        this.$store.commit('set', ['showLoader', false]);
      }
    }
  }
}
</script>

<style scoped>
/* Two options on one row; children must not grow to 100% width (would stack/wrap) */
.navigation-style-radios {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 1.75rem 2.5rem;
}

@media (max-width: 576px) {
  .navigation-style-radios {
    flex-wrap: wrap;
  }
}

.navigation-style-option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: flex-start;
  flex: 0 0 auto;
  max-width: 48%;
  gap: 0.45rem;
}

@media (max-width: 576px) {
  .navigation-style-option {
    max-width: 100%;
  }
}

.navigation-style-option__head {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
}

.navigation-style-option__radio {
  position: static;
  margin: 0 !important;
  flex-shrink: 0;
  cursor: pointer;
}

.navigation-style-option__text {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: inherit;
  line-height: 1.25;
  cursor: pointer;
  user-select: none;
}

.navigation-preview {
  display: block;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;
}

.navigation-preview:focus {
  outline: none;
}

.navigation-preview:focus-visible .navigation-preview__img {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.35);
}

.navigation-preview__img {
  display: block;
  width: auto;
  max-width: 220px;
  max-height: 112px;
  height: auto;
  object-fit: contain;
  border: none;
  background: transparent;
}

/* Wide, short PNG: explicit height so the diagram scales up and stays legible */
.navigation-preview--shift-panel {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 360px;
}

.navigation-preview__img--shift-panel {
  display: block;
  width: auto;
  max-width: 100%;
  height: 156px;
  max-height: none;
  object-fit: contain;
}
</style>
